"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.todayOrFormatInTimeZone = exports.formatInTimeZone = void 0;
const date_fns_tz_1 = require("date-fns-tz");
const date_fns_1 = require("date-fns");
const DateFormats_1 = require("../constants/DateFormats");
const formatInTimeZone = (date, format, timeZone) => {
    return (0, date_fns_tz_1.formatInTimeZone)(date, timeZone, DateFormats_1.FORMATS[format]);
};
exports.formatInTimeZone = formatInTimeZone;
/*
  Formats a date in the given format for the given timezone or `Today` if it is today
*/
const todayOrFormatInTimeZone = (date, format, timeZone) => {
    if ((0, date_fns_1.isToday)(date)) {
        return 'Today';
    }
    return (0, exports.formatInTimeZone)(date, format, timeZone);
};
exports.todayOrFormatInTimeZone = todayOrFormatInTimeZone;
//# sourceMappingURL=date.js.map